import i18n from './i18n';

import ImporterPage from './pages/importer';
import GlobalFiltersPage from './pages/globalFilters';
import SearchVehiclePage from './pages/searchVehicle';
import SearchReferencePage from './pages/searchReference';
import PublicationPage from './pages/publication';

import UnderDevelopmentPage from './pages/underDevelopment';

import importerMenuIcon from './assets/svgs/importerMenuIcon.svg';
import globalFiltersIcon from './assets/svgs/globalFiltersMenuIcon.svg';
import searchMenuIcon from './assets/svgs/searchMenuIcon.svg';
import publicationMenuIcon from './assets/svgs/publicationMenuIcon.svg';
import bannersMenuIcon from './assets/svgs/bannersMenuIcon.svg';
import notificationMenuIcon from './assets/svgs/notificationMenuIcon.svg';
import usersPerfilMenuIcon from './assets/svgs/usersPerfilMenuIcon.svg';

const routes = [
  {
    name: i18n.t('sideMenu.importerMenuOption'),
    icon: importerMenuIcon,
    path: i18n.t('routes.importerPage'),
    pageComponent: ImporterPage,
  },
  {
    name: i18n.t('sideMenu.globalFiltersMenuOption'),
    icon: globalFiltersIcon,
    path: i18n.t('routes.globalFiltersPage'),
    pageComponent: GlobalFiltersPage,
    needImport: true,
  },
  {
    name: i18n.t('sideMenu.searchRefMenuOption'),
    icon: searchMenuIcon,
    path: i18n.t('routes.searchRefPage'),
    pageComponent: SearchReferencePage,
  },
  {
    name: i18n.t('sideMenu.searchVehicleMenuOption'),
    icon: searchMenuIcon,
    path: i18n.t('routes.searchVehiclePage'),
    pageComponent: SearchVehiclePage,
  },
  {
    name: i18n.t('sideMenu.publicationMenuOption'),
    icon: publicationMenuIcon,
    path: i18n.t('routes.publicationPage'),
    pageComponent: PublicationPage,
    hasPublishNotifications: true,
    enableOnPublish: true,
    hasDivider: true,
  },
  {
    name: i18n.t('sideMenu.bannersMenuOption'),
    icon: bannersMenuIcon,
    pageComponent: UnderDevelopmentPage,
  },
  {
    name: i18n.t('sideMenu.notificationsMenuOption'),
    icon: notificationMenuIcon,
    pageComponent: UnderDevelopmentPage,
    hasDivider: true,
  },
  {
    name: i18n.t('sideMenu.userPerfilsMenuOption'),
    icon: usersPerfilMenuIcon,
    pageComponent: UnderDevelopmentPage,
  },
];

export default routes;
